// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./toaster.types.d.ts" />
import { createContext, useContext } from "react";

import type { FlashApi } from "./flash.api";
import type { SnackApi } from "./snack.api";
import type { ToastApi } from "./toast.api";

export type ToasterContextType = {
  toast: ToastApi;
  flash: FlashApi;
  snack: SnackApi;
};

export const ToasterContext = createContext<ToasterContextType | null>(null);

export function useToasters(_options: {
  unsafe: true;
}): Partial<ToasterContextType>;
export function useToasters(_options?: never): ToasterContextType;
export function useToasters(options?: {
  unsafe: true;
}): Partial<ToasterContextType> {
  const context = useContext(ToasterContext);
  if (!context && !options?.unsafe) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context ?? {};
}
